import { z } from 'zod';

export const salesModuleSchema = z.object({}).default({});
